module.exports = __webpack_public_path__ + "img/trip_sendai19.e839578b.jpg";